import { useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Result } from "antd";
import CustomButton from "../components/CustomButton";
import styles from "./OrderSubmitSuccess.module.css";

export function OrderSubmitSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderId } = useParams();

  // Get data from navigation state
  const orderNo = location.state?.orderNo;
  const orderStatus = location.state?.orderStatus;
  const orderAuditStatus = location.state?.orderAuditStatus;

  useEffect(() => {
    // Prevent direct access without proper state
    if (!orderId) {
      navigate("/orders");
    }
  }, [orderId, navigate]);

  const handleBackToList = () => {
    navigate("/orders");
  };

  const handleContinueEdit = () => {
    if (orderId) {
      // 跳转到编辑页面,不传递 initialStep,让自动判断逻辑根据完成状态决定步骤
      navigate(`/orders/${orderId}/edit`, {
        state: {
          orderStatus,
          orderAuditStatus,
        },
      });
    }
  };

  return (
    <div className={styles.container}>
      <Result
        status="success"
        title="訂單提交成功!"
        subTitle={
          orderNo ? (
            <div>
              訂單編號：<span style={{ fontWeight: 500 }}>{orderNo}</span>
            </div>
          ) : (
            "您的訂單已成功提交，我們將盡快處理。"
          )
        }
        extra={[
          <CustomButton
            key="continue"
            height={40}
            fontSize={16}
            bgColor="#00C7B6"
            color="#fff"
            onClick={handleContinueEdit}
            block
            className={styles.primaryButton}
          >
            繼續操作
          </CustomButton>,
          <CustomButton
            key="back"
            height={40}
            fontSize={16}
            bgColor="#fff"
            color="#666"
            style={{ border: "1px solid #d9d9d9" }}
            onClick={handleBackToList}
            block
          >
            返回訂單紀錄
          </CustomButton>,
        ]}
      />
    </div>
  );
}
